import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import RootProvider from './providers/root.tsx';
import { Toaster } from 'react-hot-toast';
import * as Sentry from '@sentry/react';
import 'ui_2/src/index.css';

Sentry.init({
  dsn: 'https://a60ae1abe5383865fb8d20896ecd274d@o4508779138580480.ingest.us.sentry.io/4508779212701696',
  ignoreErrors: [/window\.android\.test/],
  integrations: [Sentry.captureConsoleIntegration({ levels: ['error'] })],
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RootProvider>
      <App />
    </RootProvider>
    <Toaster position='bottom-center' />
  </React.StrictMode>
);
